import mitt, { Emitter } from "mitt";
import { PopupsEnum } from "./popups";
import { IAuthPopupProps } from "components/UI/Popups/AuthPopup";
import { IAddToNichePopupProps } from "components/niches/AddToNichePopup";
import { IReportPopupProps } from "components/UI/Popups/Report";
import { IAddToCollectionPopupProps } from "components/UI/Popups/Collections";
import { IEditNichePopupContainerProps } from "components/popups/EditNichePopup";
import { IEditNichesDialogProps } from "components/dialogs/EditNichesDialog";
import { IGifPreferencePopupProps } from "components/UI/Popups/GifPreferencePopup";
import { IShareGifMenuProps } from "components/UI/ShareMenu";
import { IMoreMenuContainerProps } from "components/popups/MoreMenu";
import { INicheMoreMenuContainerProps } from "components/popups/NicheMoreMenu";
import { IEditGifPopupProps } from "components/popups/EditGifPopup";

type CommonPopupEvent = {
  name: PopupsEnum;
};

type OpenAuthPopupEvent = CommonPopupEvent & IAuthPopupProps;
type OpenAddNicheEvent = CommonPopupEvent & IAddToNichePopupProps;
type OpenReportEvent = CommonPopupEvent & IReportPopupProps;
type OpenAddCollectionEvent = CommonPopupEvent & IAddToCollectionPopupProps;
type OpenEditNicheEvent = CommonPopupEvent & IEditNichePopupContainerProps;
type OpenEditGifNichesEvent = CommonPopupEvent & IEditNichesDialogProps;
type OpenEditGifPreferencesEvent = CommonPopupEvent & IGifPreferencePopupProps;
type OpenShareGifEvent = CommonPopupEvent & IShareGifMenuProps;
type OpenMoreMenuEvent = CommonPopupEvent & IMoreMenuContainerProps;
type OpenEditGifEvent = CommonPopupEvent & IEditGifPopupProps;
type OpenNicheMoreMenuEvent = CommonPopupEvent & INicheMoreMenuContainerProps;
type OpenAddToNicheSuccessEvent = CommonPopupEvent;

export type OpenPopupEvent =
  CommonPopupEvent
  | OpenAuthPopupEvent
  | OpenAddNicheEvent
  | OpenReportEvent
  | OpenAddCollectionEvent
  | OpenEditNicheEvent
  | OpenEditGifNichesEvent
  | OpenEditGifPreferencesEvent
  | OpenShareGifEvent
  | OpenMoreMenuEvent
  | OpenEditGifEvent
  | OpenNicheMoreMenuEvent
  | OpenAddToNicheSuccessEvent
  ;

export type ClosePopupEvent = {
  name: PopupsEnum;
}

export enum PopupBusEventsKeysEnum {
  OpenEventKey = "open",
  CloseEventKey = "close",
}

type PopupBusEvents = {
  [PopupBusEventsKeysEnum.OpenEventKey]: OpenPopupEvent;
  [PopupBusEventsKeysEnum.CloseEventKey]: ClosePopupEvent;
};

type BusType = Emitter<PopupBusEvents>;

export const popupBus: BusType = mitt<PopupBusEvents>();
